module.exports = __webpack_public_path__ + "54b72510c4894b38d65f0e8e9437428d.gif";